import { render, staticRenderFns } from "./estates.vue?vue&type=template&id=4dbb3616&scoped=true"
import script from "./estates.vue?vue&type=script&lang=js"
export * from "./estates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb3616",
  null
  
)

export default component.exports